import React, { useEffect } from 'react';
import { useTable, useExpanded } from 'react-table';
import MaUTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
 
  getStudentsMarksByCourseOffering,
  getCourseEvaluationComponentByCourseOfferingId,
  getCourseEvaluationSubcomponentByComponentId,
  getGradingDetails,
} from '../../Utils/apiServices';
import KenCard from '../../global_components/KenCard';
import routes from '../../Utils/routes.json';
import { Typography } from '@material-ui/core';
import Filters from '../../Components/Filters/Filters';
import KenLoader from '../../Components/KenLoader';
import { Newtable } from '../../Components/NewTablecomponents/NewTablecomponent';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {makeStyles} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  profile: {
    color: theme.palette.KenColors.primary,
    cursor: 'pointer',
    fontSize: 12,
    textAlign: 'left',
    paddingLeft: '10px'
  },
}));

function Table({ columns: userColumns, data, renderComponents }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { expanded },
  } = useTable(
    {
      columns: userColumns,
      data,
    },
    useExpanded // Use the useExpanded plugin hook
  );

  return (
    <>
      <MaUTable {...getTableProps()}>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TableCell {...column.getHeaderProps()}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>

        <TableBody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <React.Fragment {...row.getRowProps()}>
                <TableRow>
                  {row.cells.map((cell) => {
                    return (
                      <TableCell {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </TableCell>
                    );
                  })}
                </TableRow>
                {row.isExpanded ? (
                  <TableRow>
                    <TableCell colSpan={visibleColumns.length}>
                      {/*
                        Inside it, call our renderRowSubComponent function. In reality,
                        you could pass whatever you want as props to
                        a component like this, including the entire
                        table instance. But for this example, we'll just
                        pass the row
                      */}
                      {renderComponents({ row })}
                    </TableCell>
                  </TableRow>
                ) : null}
              </React.Fragment>
            );
          })}
        </TableBody>
      </MaUTable>
    </>
  );
}

export default function StudentsMarksBySection() {
  
  const classes=useStyles();

  const history = useHistory();
  // Profile Cell
  const ProfileCell = (row) => {
    const { studentName} = row.row.values;
    return (
      <Typography
      className={classes.profile}
        onClick={() => onProfileView(row?.row?.original)}
      >
        {studentName}
      </Typography>
    );
  };
  const onProfileView = (data) => {
      if(data){
      history.push({
        pathname: `${routes.studentreport}`,
        state: { studentId: data.studentId }
      });
    }
    }
  
  
  const columns = React.useMemo(
    () => [
      // {
      //   // Make an expander cell
      //   Header: () => null, // No header
      //   id: 'expander', // It needs an ID
      //   Cell: ({ row }) => (
      //     // Use Cell to render an expander for each row.
      //     // We can use the getToggleRowExpandedProps prop-getter
      //     // to build the expander.
      //     <span {...row.getToggleRowExpandedProps()}>
      //       {row.isExpanded ? '👇' : '👉'}
      //     </span>
      //   ),
      // },
      {
        Header: 'Student',
        accessor: 'studentName',
        // Cell: ({ row }) => (
        //       <Link to={{
        //         pathname:'/app/grading/studentreport',
        //         state:{
        //           studentId:row.original.studentId
        //         }
        //       }}>{row.original.studentName}</Link>
        //     ),
        Cell: ProfileCell,
      },
      {
        Header: 'Marks',
        columns: [
          {
            Header: 'Max',
            accessor: 'maximumMarks',
          },
          {
            Header: 'Obtained',
            accessor: 'marksObtained',
          },
        ],
      },
      {
        Header: 'Percentage',
        accessor: 'percentage',
      },
      {
        Header: 'Grade',
        accessor: 'gradePoint',
      },
      {
        Header: 'Penalty',
        accessor: 'penalty',
      },
      {
        Header: 'Final Grade',
        accessor: 'finalLetterGrade',
      },
      {
        Header: 'Credits',
        columns: [
          {
            Header: 'Total',
            accessor: 'credits',
          },
          {
            Header: 'Earned',
            accessor: 'creditsEarned',
          },
        ],
      },
      {
        Header: 'Status',
        accessor: 'passFailStatus',
      },
    ],
    []
  );

  const [data, setData] = React.useState([]);
  const [courseData, setCourseData] = React.useState([]);
  const [courseEvalutionopt, setCourseEvalutionopt] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [sectionId,setSectionID]=React.useState('')


  // React.useEffect((res) => {
  //   getStudentsMarksByCourseOffering()
  //     .then((res) => {
  //       setData(res);
  //     }).catch((err) => {
  //       console.log('Err: ', err);
  //     });
  // }, []);

  const renderComponents = React.useCallback(
    ({ row }) => <ComponentsMarksTable data={row.original} />,
    []
  );

    //   const handleSectionChange=(e)=>{
    //       console.log("section id",e.target.value);
    //       setLoading(true)
    //     getCourseEvaluationComponentByCourseOfferingId(e.target.value).then((res)=>{
    //       setCourseData(res.data)
    //       setLoading(false)
    //         console.log(res.data);
    //     })
    //     .catch(err=>{
    //       console.log("Err: ", err);
    //       setLoading(false)
    //   })

    //   }

    //   const handleCourseEvaluation=(e)=>{

  //   }

  //  useEffect(()=>{
  //         const CourseEvaluation=[]
  //       courseData?.map((items)=>{
  //         CourseEvaluation.push(
  //           {
  //             label: items.componentName,
  //             value: items.id,
  //           }
  //         )
  //      });

  //      setCourseEvalutionopt(CourseEvaluation)
  //  },[courseData])

  //   }

  //  useEffect(()=>{
  //         const CourseEvaluation=[]
  //       courseData?.map((items)=>{
  //         CourseEvaluation.push(
  //           {
  //             label: items.componentName,
  //             value: items.id,
  //           }
  //         )
  //      });

  //      setCourseEvalutionopt(CourseEvaluation)
  //  },[courseData])
  const handleSectionChange = (e) => {
    console.log('section id', e.target.value);
    setSectionID(e.target.value)

  };
  React.useEffect((res) => {
    
    if(sectionId){
      setLoading(true)
      getGradingDetails(sectionId)
      .then((res) => {
        setData(res);
        setLoading(false)
      })
      .catch((err) => {
        console.log('Err: ', err);
        setLoading(true)
      });
    }
  }, [sectionId]);

  

  return (
    <div>
      {loading && <KenLoader />}
      <Typography>Students Marks By Course offering</Typography>

      <KenCard>
        {/* Choosing CourseOffering dropdowns */}
      <Filters
      term={true}
      handleSectionChange={handleSectionChange}
      CourseVersion={true}
      courseoff={true}
      setSectionData={setData}
      sectionId={sectionId}
      setSelectedID={setSectionID}
      />
      </KenCard>

     

      <div>
        {data.length && (
          <Newtable
            columns={columns}
            data={data}
            renderComponents={renderComponents}
          />
        )}
      </div>
    </div>
  );
}

const ComponentsMarksTable = ({ data }) => {
  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? '👇' : '👉'}
          </span>
        ),
      },
      {
        Header: 'Component',
        accessor: 'name',
      },
      {
        Header: 'Max Marks',
        accessor: 'maxMarks',
      },
      {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Marks In course',
        accessor: 'marksInCourse',
      },
    ],
    []
  );

  const renderRowSubComponent = React.useCallback(
    ({ row }) => <SubComponentsMarksTable data={row.original} />,
    []
  );

  return (
    <>
      {data?.components?.length && (
        <Table
          columns={columns}
          data={data?.components}
          renderComponents={renderRowSubComponent}
        ></Table>
      )}
    </>
  );
};

function SubComponentsMarksTable({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Sub Component',
        accessor: 'name',
        render: ({ value, row }) => (
          <a
            href={`${routes.studentsMarksBySubComponent}/${row?.original?.id}`}
            target="_blank"
          >
            {value}
          </a>
        ),
      },
      {
        Header: 'Max Marks',
        accessor: 'maxMarks',
      },
      {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Component Marks',
        accessor: 'marksInComponent',
      },
      {
        Header: 'Score Finalized',
        accessor: 'fianlized',
      },
    ],
    []
  );

  return (
    <>
      {data?.subComponents && (
        <Table data={data?.subComponents} columns={columns} />
      )}
    </>
  );
}
